import { tv } from 'tailwind-variants';

export const listDividerVariants = tv({
  base: 'border-b border-divider border-b-solid h-0',
  variants: {
    padded: {
      true: 'mx-sm',
    },
    size: {
      small: 'my-3xs',
      default: 'my-xs',
    },
  },
  defaultVariants: {
    padded: false,
    size: 'default',
  },
});
